// api.js
import axios from 'axios';
import { API_BASE_URL, USUARIOACCION, FECHAHORA, LOGERRORINSERT, AUDITORIA, TIEMPOEXPIRACIONCOOKIEENMINUTOS } from '../services/apiConfig';



export const registrarAccionvv = async (usuario, navega) => {

  const insertUserNavegate = {
      usuarioid: usuario,
      navego: navega,
      
    };

  axios.post(API_BASE_URL + USUARIOACCION, insertUserNavegate)
  .then((response) => {
     
    });
};

export const registrarAccion = async (usuario, navega) => {
  try {
    const response = await axios.post(API_BASE_URL + USUARIOACCION, {
      usuarioid: usuario,
      navego: navega,
    });

    // Verifica si la solicitud fue exitosa
    if (response.status === 200) {
      console.log('Registro de error exitoso:', response.data);
      // Puedes realizar cualquier acción adicional aquí después de registrar el error
    } else {
      console.error('Error al registrar el error:', response.status);
      registrarLogError(usuario, navega,  response.status);
    }
  } catch (error) {
    console.error('Error al realizar la solicitud:', error.message);
    registrarLogError(usuario, navega,  JSON.stringify(error));
  }
};



export const registrarLogError = async (usuario, aplicacion, error) => {
  try {
    const response = await axios.post(API_BASE_URL + LOGERRORINSERT, {
      usuarioid: usuario,
      error: error,
      aplicacion: aplicacion,
    });

    // Verifica si la solicitud fue exitosa
    if (response.status === 200) {
      console.log('Registro de error exitoso:', response.data);
      // Puedes realizar cualquier acción adicional aquí después de registrar el error
    } else {
      console.error('Error al registrar el error:', response.status);
    }
  } catch (error) {
    console.error('Error al realizar la solicitud:', error.message);
    // Maneja el error de manera adecuada, como mostrar un mensaje al usuario o realizar un seguimiento
  }
};

  export const getServerDateTime = async () => {
    try {
      const response = await axios.get(API_BASE_URL + FECHAHORA);
      return response.data.serverDateTime;
    } catch (error) {
      console.error('Error al obtener la fecha y hora del servidor:', error);
      throw error; // Puedes manejar el error de otra manera según tus necesidades
    }
  };

  export const getServerHora = async () => {
    try {
      const response = await axios.get(API_BASE_URL + FECHAHORA);
      return response.data.serverHora;
    } catch (error) {
      console.error('Error al obtener la hora del servidor:', error);
      throw error; // Puedes manejar el error de otra manera según tus necesidades
    }
  };


  export const registrarAuditoria = async (operacion,tabla,clave,campo,datoanterior,datoactualizado,aplicacion, usuario) => {
    try {
      const response = await axios.post(API_BASE_URL + AUDITORIA, {
        operacion : operacion,
        tabla: tabla,
        clave: clave,
        campo:campo,
        datoanterior: datoanterior,
        datoactualizado: datoactualizado,
        aplicacion: aplicacion,
        usuarioid: usuario,
      });
  
      // Verifica si la solicitud fue exitosa
      if (response.status === 200) {
        console.log('Registro de error exitoso:', response.data);
        // Puedes realizar cualquier acción adicional aquí después de registrar el error
      } else {
        console.error('Error al registrar el error:', response.status);
      }
    } catch (error) {
      console.error('Error al realizar la solicitud:', error.message);
      // Maneja el error de manera adecuada, como mostrar un mensaje al usuario o realizar un seguimiento
    }
  };



  export const isAuthenticated = (componente) => {
    const token = sessionStorage.getItem('authToken');
    const expiryTime = sessionStorage.getItem('expiryTime');
    const currentTime = new Date().getTime();
    const loggedIn =  sessionStorage.getItem('loggedIn');

    if (loggedIn && token && expiryTime && currentTime < expiryTime) {

      const maxAge = TIEMPOEXPIRACIONCOOKIEENMINUTOS * 60; // Convertir minutos a segundos
      const expiryTime = new Date().getTime() + maxAge * 1000;
      sessionStorage.setItem("expiryTime", expiryTime); //actualizo la la expiracion

      return true;
    }
    
    registrarLogError('unlogin',componente,'usuario no logueado. token: '+token);

    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('expiryTime');
    sessionStorage.removeItem('loggedIn');
    sessionStorage.clear();

    return false;
  };